/* eslint-disable */
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['labels', 'orderCountArray', 'orderAmountArray'],
  watch: {
    labels: function (newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.$data.chartdata.labels = newVal;
        this.renderChart(this.chartdata, this.options);
      }
    },
    orderCountArray: function (newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.$data.chartdata.datasets[0].data = newVal;
        this.renderChart(this.chartdata, this.options);
      }
    },
    orderAmountArray: function (newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.$data.chartdata.datasets[1].data = newVal;
        this.renderChart(this.chartdata, this.options);
      }
    }
  },
  data: () => ({
    chartdata: {
      datasets: [
        {
          label: 'Número de pedidos',
          data: [10, 20, 30, 40, 83, 20, 5],
          backgroundColor: 'rgba(26,179,148, .6)',
          yAxisID: 'first-y-axis'
        },
        {
          label: 'Pagamentos',
          data: [100, 200, 300, 100, 230, 200, 99.84],
          backgroundColor: 'rgba(70,79,136, .4)',
          type: 'line',
          yAxisID: 'second-y-axis',
        }
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [{
          id: 'first-y-axis',
          type: 'linear',
          suggestedMin: 0,
          beginAtZero: true,
          ticks: {
            suggestedMin: 0,
          }
        }, {
          id: 'second-y-axis',
          type: 'linear',
          position: 'right',
          suggestedMin: 0,
          beginAtZero: true,
          ticks: {
            suggestedMin: 0,
            // Include a dollar sign in the ticks
            callback: function (value, index, values) {
              return 'R$ ' + value;
            }
          }
        }]
      }
    }
  }),
  mounted() {
    this.$data.chartdata.labels = this.labels;
    this.$data.chartdata.datasets[0].data = this.orderCountArray;
    this.$data.chartdata.datasets[0].order = 2;
    this.$data.chartdata.datasets[1].data = this.orderAmountArray.map(value => {
      return parseFloat(value.toFixed(2));
    });
    this.$data.chartdata.datasets[1].order = 1;
    this.renderChart(this.chartdata, this.options);
  },
}